<div id="questCompleteContainer" class="questCompleteModal text-center">
  <div class="modal-header">
    <h3 class="modal-title pb-0 fw-bold">Quest Complete!</h3>
  </div>
  <div class="body-section">
    <div class="d-flex align-items-start flex-nowrap justify-content-center mx-auto">
      <div><i class="fas fa-circle-check me-2 text-success" aria-hidden="true"></i></div>
      <h5 class="text-start pt-1">{{currentQuest.label()}}</h5>
    </div>
    <p class="d-flex flex-nowrap justify-content-center my-3 fw-normal">
      You got <img role="presentation" alt="" src="assets/img/star.png" class="starIconQuestModal mx-1"> {{currentQuest.numberOfStarsToEarn}} Stars for completing this quest.
    </p>
    <p class="d-flex flex-nowrap justify-content-center my-2">
       Stars are earned by completing activities and quests in the portal
    </p>
    <p class="d-flex flex-nowrap justify-content-center mb-2">
      Earn stars to level up your blob!
    </p>
    <div class="footer pt-2">
      <button type="button" class="btn btn-sm skButton" (click)="confirm()">OK!</button>
    </div>
  </div>
</div>
